import { Link, withStyles } from '@material-ui/core';
import { colors } from '../../../assets/colors';

// Mui Link components inherits Typography props, classnames etc.
export const MuiCMLink = withStyles(() => ({
    root: {
        color: colors.primaryButton,
    },
}))(Link);
